import { render } from "./RecordFields.vue?vue&type=template&id=e29e7c72&scoped=true&ts=true"
import script from "./RecordFields.vue?vue&type=script&lang=ts"
export * from "./RecordFields.vue?vue&type=script&lang=ts"

import "./RecordFields.vue?vue&type=style&index=0&id=e29e7c72&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e29e7c72"]])

export default __exports__